import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isStopOver } from '../../../utils/url/url';
import FlightDetailsHead from '../flightDetailsHead/FlightDetailsHead';

import './BaggageDetails.scss';

const BaggageDetails = ({ isIncluded, flights, labels }) => {
  const introText = isIncluded ? labels.luggageDetails_luggageIncluded : labels.luggageDetails_luggageNotIncluded;

  const isStopover = isStopOver();

  const getFlightInfoText = (texts) => {
    const infoTexts = [];
    if (texts !== null) {
      texts.forEach((text) => {
        infoTexts.push(<span key={uniqid('baggage-text-')}>{text}</span>);
      });
    } else {
      infoTexts.push(<span>{labels.luggageDetails_infoMissing}</span>);
    }
    return infoTexts;
  };

  return (
    <div
      className={classNames('iw-flight-list-baggage-details', {
        'iw-flight-list-baggage-details--stopover': isStopover,
      })}
    >
      {flights.map((flight) => (
        <div key={flight.departureDateTime}>
          <FlightDetailsHead
            flight={flight}
            labels={labels}
            hideFlightTime
            withCarrierInfo
            carrierAdditionalText={introText}
          />
          {flight.legs.map((leg) => {
            return (
              <div key={uniqid('cabin-class-leg-')}>
                <p className="iw-flight-list-flight-class__departure-location">
                  {`${labels.from} ${leg.departureLocation}`}
                </p>
                <div className="iw-flight-list-baggage-details__subtile-text">
                  {getFlightInfoText(flight.luggageTexts)}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

BaggageDetails.propTypes = {
  isIncluded: PropTypes.bool.isRequired,
  flights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  labels: PropTypes.shape({
    luggageDetails_luggageIncluded: PropTypes.string,
    luggageDetails_luggageNotIncluded: PropTypes.string,
    luggageDetails_infoMissing: PropTypes.string,
    from: PropTypes.string,
  }).isRequired,
};

export default BaggageDetails;
